import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=f18058de&scoped=true"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18058de",
  null
  
)

export default component.exports